import { useDatabase } from "@nozbe/watermelondb/hooks";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useEffect, useState } from "react";
import { Text, View } from "react-native-ui-lib";
import { FlatActionList } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { ReceiptModalRootParmList } from "../../../../types";
import ReceiptTemplate from "../../../../utilities/data/model/ReceiptTemplate";
import { useSaleContextProvider } from "../../utils";
import { useDownloadReceipt } from "../../../../utilities/receipt/use-download-receipt";
import React from "react";
import { useTranslation } from "../../../../utilities/i18n";

export type DownloadReceiptScreenProps = NativeStackScreenProps<
  ReceiptModalRootParmList,
  "DownloadReceiptScreen"
>;

// this will only work for web , mobile will need to use a different approach
export const DownloadReceiptScreen = ({
  navigation,
  route,
}: DownloadReceiptScreenProps) => {
  const { t } = useTranslation("sales");
  const [loading, setLoading] = React.useState(false);
  const { sale } = useSaleContextProvider();

  const { downloadReceipt } = useDownloadReceipt();

  const [receiptTemplates, setReceiptTemplates] = useState<
    ReceiptTemplate[] | undefined
  >();

  const database = useDatabase();

  useEffect(() => {
    database
      .get<ReceiptTemplate>("receipt_template")
      .query()
      .fetch()
      .then((i) => setReceiptTemplates(i));
  }, []);

  const items =
    receiptTemplates?.map((i) => ({
      key: i.id,
      title: i.name,
      subTitle: i.receiptTemplateType.id,
      disabled: loading,
      onPress: () => {
        setLoading(true);
        sale &&
          downloadReceipt(sale.id, i.id)
            .then(() => navigation.getParent()?.goBack())
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
      },
    })) || [];

  const noContentMarkup =
    receiptTemplates !== undefined && receiptTemplates.length == 0 ? (
      <Text>{t("no_receipt_template")}</Text>
    ) : undefined;

  return (
    <Page>
      <View>
        {noContentMarkup}
        {sale ? <FlatActionList items={items} /> : undefined}
      </View>
    </Page>
  );
};
